import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js"
import { Bar } from "react-chartjs-2"
import { CustomChartType } from "../../types"
import { GeneralQueryKeys } from "../../../../api/constants"
import { useQuery } from "@tanstack/react-query"
import { getCostCenterNames } from "../../api/apiCalls"
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default function CostCenterSalesChart(props: CustomChartType) {

    const {data: costcenterdata} = useQuery({
        queryKey: [GeneralQueryKeys.COSTCENTER_NAMES],
        queryFn: getCostCenterNames,
    })
    const data = {
        labels: Object.keys(props.paymentStatistics).map((key) => costcenterdata?.find((costcenter: { _id: string }) => costcenter._id === key)?.name), 
        datasets: [
            {
                data: Object.values(props.paymentStatistics),
                backgroundColor: "rgba(5, 105, 168, 0.6)",
                borderColor: "rgba(5, 105, 168, 1)",
                borderWidth: 1,
            },
        ],
    }
    return (
        <div className="w-full md:w-fit bg-white rounded-default shadow-lg p-4 max-h-64 flex justify-center grow">
            <Bar
                className="w-full h-80 sm:h-96 md:h-fit"
                data={data}
                options={{
                    indexAxis: "y" as const,
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false,
                            position: "top",
                        },
                        title: {
                            display: true,
                            text: "Umsatz nach Niederlassung (365 Tage) in Euro",
                        },
                    },
                }}
            />
        </div>
    )
}
